<ng-container *ngIf="processing">
    <fui-ellipsis-loader></fui-ellipsis-loader>
    {{label | translate}}
</ng-container>
